import "./MyApproach.module.css";
import Header from "@/reusable_sections/Header";
import TheAuditCycle from "./sections/TheAuditCycle";
import ToolsForYourStrength from "./sections/ToolsForYourStrength";
import FaqInitialConsultation from "./sections/FaqInitialConsultation";
import Footer from "@/reusable_sections/Footer";
export default function MyApproachPage() {
  return <div>
      <Header />
      <TheAuditCycle />
      <ToolsForYourStrength />
      <FaqInitialConsultation />
      <Footer />
    </div>;
}